import React, { Component } from "react";
import Button from '../Button/Button';
import Style from './Footer.css';

class Footer extends Component{
	render(){
		return(
			<section style={Style.footer} className="footer">
				<footer>
					<div className="container">
						<div className="text-wrap">
						   YOUR FUTURE STARTS HERE 
						</div>
						<div className="button-wrap">
							<Button buttonLink="https://slate.admissions.arizona.edu/apply/" buttonId="Apply-Now-Footer" buttonTitle="APPLY NOW" />
						</div>
					</div>
				</footer>
			</section>
		)
	}
}

export default Footer;